import LayoutConstants from '@/constansts/layoutConstants';

const buildBaseItems = ({ t, myAccountMenuWideFF, newProfilePageFF }) => {
  const myAccountRoute = myAccountMenuWideFF ? 'app.setting_menu' : 'app.settings_page';
  const profileRoute = newProfilePageFF ? 'staffProfile' : 'app.business_info_settings';
  const profileRouteType = newProfilePageFF
    ? LayoutConstants.ROUTING_TYPES.pov
    : LayoutConstants.ROUTING_TYPES.angular;
  const settingsPermission = newProfilePageFF ? null : 'can_access_settings';

  return [
    {
      label: t('common.navigation.account'),
      icon: 'icon-user',
      event: 'my-account',
      roles: ['admin', 'manager', 'marketing'],
      permission: 'can_access_settings',
      routingType: LayoutConstants.ROUTING_TYPES.angular,
      route: myAccountRoute,
      routeData: { page: 'my_account' },
    },
    {
      label: t('common.navigation.profile'),
      icon: 'icon-Suitcase',
      event: 'business-info',
      roles: ['admin', 'manager', 'marketing'],
      permission: 'can_access_settings',
      routingType: profileRouteType,
      route: profileRoute,
    },
    {
      label: t('common.navigation.settings'),
      icon: 'icon-Settings',
      event: 'settings',
      roles: ['admin', 'manager', 'marketing'],
      permission: settingsPermission,
      routingType: LayoutConstants.ROUTING_TYPES.angular,
      route: 'app.settings',
      routeData: {},
    },
    {
      label: t('common.navigation.staff'),
      icon: 'icon-User-vneck',
      event: 'staff',
      roles: ['admin'],
      permission: 'can_access_staff_management',
      routingType: LayoutConstants.ROUTING_TYPES.angular,
      route: 'app.settings_page',
      routeData: { page: 'staff' },
    },
  ];
};

export const buildAccountMenuItems = ({
  t,
  myAccountMenuWideFF,
  newProfilePageFF,
  hasGettingStartedDeny,
  hasRolesAndPermissions,
  hasPermission,
  staffRole,
}) => {
  const items = buildBaseItems({ t, myAccountMenuWideFF, newProfilePageFF });

  if (!hasGettingStartedDeny) {
    items.push({
      label: t('onboarding.new_onboarding.quick_btn_title'),
      icon: 'icon-Rocket_new',
      event: 'getting-started',
      roles: ['admin'],
      permission: 'can_access_admin_account',
      action: 'openChecklist',
    });
  }

  if (hasRolesAndPermissions) {
    return items.filter((item) => (item.permission ? hasPermission(item.permission) : true));
  }

  return items.filter((item) => item.roles.includes(staffRole || ''));
};

export const getUserProfileDetails = (staffData, attributes) => ({
  imagePath: staffData?.photo_path || attributes?.photo_path || '',
  email: staffData?.email || '',
  displayName: staffData?.display_name || '',
  colorId: staffData?.color_id || 27,
});
